import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LoadBank } from "../models/LoadBank";
import { LoadBankGenerator } from "../models/LoadBankGenerator";
import { LoadBankApplyParameters } from "../models/LoadBankApplyParameters";
import { LoadBankApplyInfo } from "../models/LoadBankApplyInfo";
import { LoadBankItem } from "../models/LoadBankItem";
import { LoadBankApplyLoads } from "../models/LoadBankApplyLoads";

@Injectable({
    providedIn: 'root'
})
export class LoadBankDataService {
    constructor(private http: HttpClient) {

    }

    getLoadBankByLoc(loadBankParms): Observable<LoadBank[]> {
        return this.http.post<LoadBank[]>('api/loadbank/getloadbankbyloc/', loadBankParms);
    }

    saveLoadBankGenerator(loadBankGenerator: LoadBankGenerator): Observable<LoadBankGenerator> {
        return this.http.post<LoadBankGenerator>('api/loadbank/saveloadbankgenerator', loadBankGenerator);
    }

    deleteSelectedLoadBankRecords(selectedLoadBankIds: number[]): Observable<boolean> {
        return this.http.post<boolean>('api/loadbank/deleteselectedloadbankrecords', selectedLoadBankIds);
    }

    getLoadBankApplyInfo(parameters: LoadBankApplyParameters): Observable<LoadBankApplyInfo> {
        return this.http.post<LoadBankApplyInfo>('api/loadbank/GetLoadBankApplyInfo', parameters);
    }

    searchLoadBank(parameters: LoadBankApplyParameters): Observable<LoadBankItem[]> {
        return this.http.post<LoadBankItem[]>('api/loadbank/SearchLoadBank', parameters);
    }

    saveLoadNumbersToLoads(parameters: LoadBankApplyLoads): Observable<boolean> {
        return this.http.post<boolean>('api/loadbank/SaveLoadNumbersToLoads', parameters);
    }

}